module.exports = __webpack_public_path__ + "img/account-aktiv.2ed412f5.svg";